import { render, staticRenderFns } from "./ViewLogisticSetting.vue?vue&type=template&id=8838cbba&scoped=true"
import script from "./ViewLogisticSetting.vue?vue&type=script&lang=ts"
export * from "./ViewLogisticSetting.vue?vue&type=script&lang=ts"
import style0 from "./ViewLogisticSetting.vue?vue&type=style&index=0&id=8838cbba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8838cbba",
  null
  
)

export default component.exports